import api from '@/api'
export default {
  async checkExistdUser(email) {
    try {
      let resp = await api.request('post', '/api/v1/users/gateway/existed', true, {
        email
      })
      if (resp.status !== 200) {
        throw resp
      }
      return resp.data
    } catch (error) {
      throw error
    }
  },
  async createUserGateWay(email) {
    try {
      let resp = await api.request('post', '/api/v1/users/gateway', true, {
        email
      })
      if (resp.status !== 201) {
        throw resp
      }
      return resp.data
    } catch (error) {
      throw error
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/views/Development/Express-Gateway/express-gateway.api.js